<template>
  <v-col>
    <!-- Warehouses data table -->
    <warehouse-table
      :key="index"
      url-api="/warehouse"
      :headers="headers"
    >
      <!-- New warehouse -->
      <template #urlCreate>
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'AddNewWarehouse',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          New Warehouse
        </v-btn>
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template #columnaction="{ item }">
        <!-- Warehouse details -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'WarehouseDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Warehouse info edit -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'EditWarehouse',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Warehouse remove -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              small
              icon
              @click="warningWarehouseRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </warehouse-table>

    <!-- end data table -->

    <!-- warehouse remove confirmation dialog  -->
    <v-dialog
      v-model="warehouseRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline red--text">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove Warehouse?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="warehouseRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeWarehouse"
          >
            Remove Warehouse
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import WarehousesTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "warehouse-table": WarehousesTable,
  },
  data() {
    return {
      warehouseRemoveWarning: false,
      warehouse: [],
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Name",
          sortable: true,
          value: "name",
        },
        {
          text: "Email",
          sortable: true,
          value: "email",
        },
        {
          text: "Phone",
          sortable: true,
          value: "phone",
        },
        {
          text: "Location",
          sortable: false,
          value: "location",
        },
        {
          text: "Volume",
          sortable: true,
          value: "maxVolume",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    removeWarehouse() {
      window.axios
        .delete("/warehouse/" + this.$data.warehouse.id)
        .then((response) => {
          this.$data.warehouseRemoveWarning = false;
          this.$data.index++;
          this.feedback(response.data.message);
        });
    },
    warningWarehouseRemove(warehouse) {
      this.$data.warehouse = warehouse;
      this.$data.warehouseRemoveWarning = true;
    },
  },
};
</script>
